import { render, staticRenderFns } from "./ReminderCard.vue?vue&type=template&id=0a9440a2&scoped=true&"
import script from "./ReminderCard.vue?vue&type=script&lang=js&"
export * from "./ReminderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9440a2",
  null
  
)

export default component.exports